<template>
  <div v-drag>
    <a-modal title="查询"
             v-model:visible="dialogVisible"
             @ok="search"
              :closable="false"
             wrapClassName="my-modal-wrap"
             width="520rem">
      <a-row class="input_Warp">
        <div style="width:50rem;font-size:18rem">内容</div>
        <a-input placeholder="请输入搜索内容"
                 allowClear
                 style="flex:1"
                 v-model:value="keywords" />
      </a-row>

      <a-row class="input_Warp"
             v-show="showTag">
        <div style="width:50rem;font-size:18rem"> 标签</div>
        <a-select style="flex:1"
                  v-model:value="question_favorite_type_id"
                  placeholder="请选择"
                  allowClear
                  :options='tagList.map(item=>({label:item.type_name,value:item.question_favorite_type_id}))'>

        </a-select>
      </a-row>

      <template #footer>
        <div class="btn_warp">
          <div @click="handleClose">取消</div>
          <div @click="search">确定</div>
        </div>
      </template>

    </a-modal>
  </div>
</template>

<script setup>

import { ref, toRefs, defineExpose } from "vue"
import { collectTagList } from "@/api/collect.js"


let dialogVisible = ref(false)
let keywords = ref('')
let question_favorite_type_id = ref('')
let tagList = ref([])


let { showTag } = defineProps(['showTag'])

const emit = defineEmits(['getData'])
const handleClose = () => {
  dialogVisible.value = false
}
const search = () => {
  emit('getData', keywords.value, question_favorite_type_id.value)
  dialogVisible.value = false
}

const setData = (bool, str, tagId) => {
  dialogVisible.value = bool
  keywords.value = str
  question_favorite_type_id.value = tagId || []
}
const getTagList = async () => {
  const { data } = await collectTagList()
  tagList.value = data.list
}
getTagList()

defineExpose({
  setData,
  dialogVisible,
  showTag,
  tagList,
  keywords,
  question_favorite_type_id
})

</script>

<style lang="scss" >
.my-modal-wrap {
 .ant-modal{
top: 35%;
}
.ant-modal-content .ant-modal-header .ant-modal-title {
font-size: 20rem;
}
.ant-input-affix-wrapper{
  display: flex;
width: 480rem;
height: 56rem;
padding: 0 16rem;
align-items: center;
gap: 8rem;
border-radius: 8rem;
border: 1rem solid var(--light-cccccc, #CCC);
background: #FFF;
}
.ant-modal-content {
overflow-y: auto;  
border-radius: 20rem;
}

.text_warp {
  word-break: break-all;
  font-weight: 500;
  color: #666666 !important;
  line-height: 23rem;
  font-size: 16rem;
  padding: 27rem;
  padding-top: 0;
}

.btn_warp {
  // border-top: 1rem solid #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  // margin-bottom: -30rem;
  div {
    flex: 1;
    font-weight: 400;
    font-size: 16rem;
    // padding: 18rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:nth-child(2) {
      color: #2196f3;
      border-left: 1rem solid #e5e5e5;
    }
  }
}
:deep .ant-input-affix-wrapper > input.ant-input {
  font-size: 18rem;
}

.input_Warp {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10rem;
  span {
    flex: 1;
  }
}
}
</style>